import { render, staticRenderFns } from "./tabbed-content.vue?vue&type=template&id=6c98a1ff&"
import script from "./tabbed-content.vue?vue&type=script&lang=js&"
export * from "./tabbed-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports